import React from "react"

import { Grid } from "@material-ui/core"

import { Portlet } from "@/components"
import InfoItemInput from "@/components/InfoItemInput"
import ProfileGroupPermissionGate from "@/components/PermissionGate/ProfileGroupPermissionGate"

import ManagementUserAccessDataDialog from "@/pages/Admin/Security/ManagementUserAccessData/ManagementPasswordDialog"
import MFAInputItem from "@/pages/Admin/Security/ManagementUserAccessData//MFAInputItem"

const ManagementUserAccessData = () => {
	const handleOpenManagementPasswordDialog = (): void => {
		ManagementUserAccessDataDialog.open()
	}

	return (
		<Grid
			container
			direction="column"
			spacing={3}
		>
			<Grid
				item
			>
				<Portlet>
					<Grid
						container
						direction="column"
						spacing={3}
					>
						<Grid
							item
						>
							<MFAInputItem />
						</Grid>

						<Grid
							item
						>
							<InfoItemInput
								title="Senha"
								onEdit={handleOpenManagementPasswordDialog}
								editButtonGate={(button) => <ProfileGroupPermissionGate action="update">{button}</ProfileGroupPermissionGate>}
							/>
						</Grid>
					</Grid>
				</Portlet>
			</Grid>
		</Grid>
	)
}

export default ManagementUserAccessData
